import React, { Fragment } from 'react'
import { Breadcrumbs, UL } from '../../../../AbstractElements';
import AuditReconciliation from './AuditReconciliation';
import { Container } from 'reactstrap';

const Reconciliation = () => {
    // Same rule as the sidebar: user group has Access Audit and the concessionaire has audit enabled
    if (localStorage.getItem("accessAudit") !== "1" || localStorage.getItem("auditRequired") !== "true") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
        return null;
    }

    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent="Audit" title="Audit Reconciliation" mainTitle="Audit Reconciliation" />
                <Container fluid={true}>
                    <AuditReconciliation />
                </Container>
            </Fragment>
        </UL>
    )
}

export default Reconciliation